<template>
  <div :class="['szw-row szw-w-full szw-gap-1 szw-p-2', { 'szw-border-b szw-border-border last:szw-border-b-0': props.action !== 'period-info' }]">
    <template v-if="props.action !== 'period-info'">
      <div class="szw-row__center szw-w-12">
        <span class="szw-w-4 szw-h-4 szw-bg-section-static szw-animate-pulse szw-rounded"></span>
      </div>

      <div class="szw-h-5 szw-w-5 szw-bg-section-static szw-animate-pulse szw-rounded-full" />

      <div class="szw-col szw-mr-auto szw-gap-2">
        <span class="szw-h-3.5 szw-w-17 szw-bg-section-static szw-animate-pulse szw-rounded" />
        <span class="szw-h-3.5 szw-w-17 szw-bg-section-static szw-animate-pulse szw-rounded" />
      </div>

      <span class="szw-h-4 szw-w-4 szw-bg-section-static szw-animate-pulse szw-rounded" />
    </template>

    <template v-else>
      <span class="szw-h-3 szw-bg-section-static szw-animate-pulse szw-rounded szw-w-12" />
    </template>
  </div>
</template>

<script setup>
const props = defineProps({
  action: {
    type: String,
    default: 'common'
  }
})
</script>
